<div class="self-assessment-header">
  <span>{{pageTitles[currentPageNumber - 1]}}</span>
  <span class="self-assessment-header__icon" brtTooltip [text]="titleHint"><brt-icon [icon]="'circle-faq'"></brt-icon></span>
  <span class="self-assessment-header__pagination">{{currentPage}} / {{totalPages}}</span>
</div>
